import API from '@/api/index';

const applog = {
  state: {
  },

  mutations: {},

  actions: {
    getActionLog ({ commit }, id) {
      return new Promise((resolve, reject) => {
        API.applog
          .getActionLog(id)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default applog;



// WEBPACK FOOTER //
// ./src/store/modules/applog.js